let cachedConfig;

/**
 * Loads environment-specific config generated by CDK
 */
export async function loadRuntimeConfig() {
  if (cachedConfig) {
    return cachedConfig;
  }
  const response = await fetch('/config.json', { cache: 'no-store' });

  if (!response.ok) {
    throw new Error('Unable to load /config.json');
  }

  cachedConfig = await response.json();
  return cachedConfig;
}
